import React, { useState } from 'react';
import { useDeliveryKanbanStore } from 'store/kanbanDeliveyStore';
import { ContainerDelivery } from './styles';
import {
  Button,
  Checkbox,
  IconArrowFoward,
  Modal,
} from 'takeat-design-system-ui-kit';
import api2 from 'services/api2';
import { useQuery } from 'react-query';
import { addMessageWhatsapp } from 'utils/handleNotifyWhatsapp';
import { useAuth } from 'context/AuthContext';
import { ModalMotoboyOrders } from 'components/ModalMotoboyOrders';
import { handleWhatsappIndicator } from 'utils/handleWhatsappIndicator';

export const EveryOrdersDelivery = ({
  baskets,
  basketId,
  basketStatus,
  basketIfood,
  basketWithdrawal,
}) => {
  const colorButton = {
    accepted: '#CC8C1D',
    ready: '#CC5F14',
    ongoing: '#018CCC',
  };

  const colorContainer = {
    accepted: '#fff8eb',
    ready: '#FFF2EA',
    ongoing: '#E6F7FF',
  };

  const check = useDeliveryKanbanStore(
    (state) =>
      state.list.length > 0 &&
      state.list.every((status) => status.status === basketStatus[0])
  );
  const toggle = useDeliveryKanbanStore((state) => state.addCheckbox);
  const list = useDeliveryKanbanStore((state) => state.list);
  const clearSelection = useDeliveryKanbanStore(
    (state) => state.clearSelection
  );
  const [clickButton, setClickButton] = useState(false);
  const { user } = useAuth();

  const wppOn = localStorage.getItem('@gddashboard:wppConnected');

  const mapOrderStatus = (status, withWithdrawal) => {
    if (status === 'accepted') return 'ready';
    if (status === 'ready') return withWithdrawal ? 'delivered' : 'ongoing';
    if (status === 'ongoing') return 'delivered';
    return status;
  };

  const statusCheck = list.some((pedido) => pedido.status === 'ready');

  const [motoboySelected, setMotoboySelected] = useState(false);

  const selectedItems = baskets.filter((b) =>
    list.some((pedido) => pedido.id === b.basket.id)
  );

  async function handleItemReady() {
    setClickButton(true);
    try {
      const responses = await Promise.all(
        list.map(async (pedido) => {
          const response = await api2.put(`restaurants/orders/${pedido.id}`, {
            order_status: mapOrderStatus(pedido.status, pedido.with_withdrawal),
            ifood_id: pedido.ifood_id,
            with_withdrawal: pedido.with_withdrawal,
          });
          return response;
        })
      );
      
      // Handle WhatsApp indicator for each response
      responses.forEach((response) => {
        handleWhatsappIndicator(response.data?.whatsappIndicator);
      });
      
      setClickButton(false);
      clearSelection();

      list
        .filter(
          (pedido) =>
            wppOn === 'true' &&
            pedido.with_withdrawal &&
            pedido.status !== 'ongoing'
        )
        .map((pedido) => {
          addMessageWhatsapp({
            item: baskets.find((b) => b.basket.id === pedido.id),
            orders: [],
            user,
            status: mapOrderStatus(pedido.status, pedido.with_withdrawal),
          });
        });
    } catch (error) {
      setClickButton(false);
      console.log(error);
    }
  }

  const hasCheck = useDeliveryKanbanStore(
    (state) => state.list.length === 10 || state.list.length === basketId.length
  );

  const oneWithdrawal = selectedItems.some((item) => item.with_withdrawal);

  return (
    <>
      {check && (
        <ContainerDelivery color={colorContainer[basketStatus]}>
          <Checkbox
            label={baskets.length > 10 ? '10 primeiros' : 'Todos'}
            checked={hasCheck}
            onChange={() => {
              toggle(basketId, basketStatus[0], basketIfood, basketWithdrawal);
            }}
          />
          <Button
            icon={<IconArrowFoward />}
            customColor={colorButton[basketStatus]}
            variant="outlined"
            style={{ width: '160px' }}
            loading={clickButton}
            onClick={() => {
              if (statusCheck && !oneWithdrawal) {
                return setMotoboySelected(true);
              } else {
                return handleItemReady();
              }
            }}
          >
            Próx Etapa
          </Button>
        </ContainerDelivery>
      )}
      {motoboySelected === true && (
        <ModalMotoboyOrders
          item={''}
          items={selectedItems}
          openModalMotoboy={motoboySelected}
          clearSelection={clearSelection}
          onClose={() => setMotoboySelected(false)}
        />
      )}
    </>
  );
};
